import React from 'react';
/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="emergency" size=32 />
 */

var Emergency = function Emergency() {
  return React.createElement(React.Fragment, null, React.createElement("g", {
    clipPath: "url(#clip0_9_497)"
  }, React.createElement("path", {
    d: "M30.4 11.5V18.1C30.4 19.432 29.86 20.5 29.2 20.5H2.79998C2.13998 20.5 1.59998 19.432 1.59998 18.1V11.5",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2 12.1H20.5V10.9H29.2C29.6774 10.9 30.1352 11.0897 30.4728 11.4272C30.8104 11.7648 31 12.2226 31 12.7V19.3C31 19.7774 30.8104 20.2352 30.4728 20.5728C30.1352 20.9104 29.6774 21.1 29.2 21.1H20.5V19.9H29.2C29.3591 19.9 29.5117 19.8368 29.6243 19.7243C29.7368 19.6118 29.8 19.4592 29.8 19.3V12.7C29.8 12.5409 29.7368 12.3883 29.6243 12.2758C29.5117 12.1632 29.3591 12.1 29.2 12.1Z",
    fill: "#002D55"
  }), React.createElement("path", {
    d: "M11.5 20.5H2.79998C2.48172 20.5 2.17649 20.3736 1.95145 20.1485C1.7264 19.9235 1.59998 19.6183 1.59998 19.3V12.7C1.59998 12.3817 1.7264 12.0765 1.95145 11.8515C2.17649 11.6264 2.48172 11.5 2.79998 11.5H11.5",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8 12.1C2.64087 12.1 2.48826 12.1632 2.37574 12.2758C2.26321 12.3883 2.2 12.5409 2.2 12.7V19.3C2.2 19.4592 2.26321 19.6118 2.37574 19.7243C2.48826 19.8368 2.64087 19.9 2.8 19.9H11.5V21.1H2.8C2.32261 21.1 1.86477 20.9104 1.52721 20.5728C1.18964 20.2352 1 19.7774 1 19.3V12.7C1 12.2226 1.18964 11.7648 1.52721 11.4272C1.86477 11.0897 2.32261 10.9 2.8 10.9H11.5V12.1H2.8Z",
    fill: "#002D55"
  }), React.createElement("path", {
    d: "M19.3 1.59998H12.7C12.0373 1.59998 11.5 2.13723 11.5 2.79998V29.2C11.5 29.8627 12.0373 30.4 12.7 30.4H19.3C19.9627 30.4 20.5 29.8627 20.5 29.2V2.79998C20.5 2.13723 19.9627 1.59998 19.3 1.59998Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7 2.2C12.3687 2.2 12.1 2.46863 12.1 2.8V29.2C12.1 29.5314 12.3687 29.8 12.7 29.8H19.3C19.6314 29.8 19.9 29.5314 19.9 29.2V2.8C19.9 2.46863 19.6314 2.2 19.3 2.2H12.7ZM10.9 2.8C10.9 1.80589 11.7059 1 12.7 1H19.3C20.2941 1 21.1 1.80589 21.1 2.8V29.2C21.1 30.1941 20.2941 31 19.3 31H12.7C11.7059 31 10.9 30.1941 10.9 29.2V2.8Z",
    fill: "#002D55"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_9_497"
  }, React.createElement("rect", {
    width: "30",
    height: "30",
    fill: "white",
    transform: "translate(1 1)"
  }))));
};

export default Emergency;